<template>
    <page>
        <module title="限时折扣" enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="活动名称">
                	<c-input name="activity_name" placeholder="模糊匹配"></c-input>
                </m-search-item>
				<m-search-item label="活动状态" style="width:400px">
					<c-checkbox-group name="start_state" :options="activityState"></c-checkbox-group>
				</m-search-item>
            </m-search>

            <m-operate>
                <c-button v-if="auth('b_limit_time_discount_edit')" @click="navigateTo('/limit_time_discount_add')">新建活动</c-button>
            </m-operate>

            <c-table ref="table">
              <c-table-column
                  label="启/禁用状态"
                  name="state"
              >
                <template v-slot="{data}">
                  <span v-if="data.state == 2" style="color:green">启用</span>
                  <span v-if="data.state == 1" style="color:red">禁用</span>
                </template>
              </c-table-column>

              <c-table-column
                  label="活动状态"
                  name="start_state"
              >
                <template v-slot="{data}">
                  <span v-if="data.start_state == 0" style="color:#999">{{activityStateText[data.start_state]}}</span>
                  <span v-if="data.start_state == 1" style="color:dodgerblue">{{activityStateText[data.start_state]}}</span>
                  <span v-if="data.start_state == 2" style="color:#999">{{activityStateText[data.start_state]}}</span>
                  <span v-if="data.start_state == 3" style="color:red">{{activityStateText[data.start_state]}}</span>
                </template>
              </c-table-column>

                <c-table-column
                        label="活动名称"
                        name="activity_name"
                        width="200"
                ></c-table-column>

              <c-table-column
                  label="活动预告"
                  name="activity_notice"
                  width="120"
              >
                <template v-slot="{data}">
                  <span v-if="data.activity_notice == -1" style="color:gray">不预告</span>
                  <span v-if="data.activity_notice == 0" style="color:blue">立即预告</span>
                  <span v-if="data.activity_notice == 1">提前<span style="color:red">{{data.activity_notice_time}}</span>小时预告</span>
                </template>
              </c-table-column>

                <c-table-column
                    label="参与方式"
                    name="commodity_range"
                    width="100"
                >
                  <template v-slot="{data}">
                    <span v-if="data.commodity_range == 1" style="color:dodgerblue">{{commodityTange[data.commodity_range]}}</span>
                    <span v-if="data.commodity_range == 2" style="color:yellowgreen">{{commodityTange[data.commodity_range]}}</span>
                  </template>
                </c-table-column>

              <c-table-column
                  label="活动标签"
                  name="tags"
              ></c-table-column>

                <c-table-column
                    label="支付订单数"
                    name="order_count"
                ></c-table-column>

                <c-table-column
                        label="活动时间"
                        width="300"
                >
                    <template v-slot="{data}">{{data.begin_date}} 至 {{data.end_date}}</template>
                </c-table-column>
				
				<c-table-column
				        label="创建时间"
				        width="140"
						name="create_date"
				>
				</c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="230"
                >
                    <template v-slot="row">
                      <c-table-button v-if="auth('b_limit_time_discount_state') && row.data.state == 2 && row.data.start_state != 2" @click="disableActivity(row,1)">禁用</c-table-button>
                      <c-table-button v-if="auth('b_limit_time_discount_state') && row.data.state == 1 && row.data.start_state != 2" @click="disableActivity(row,2)">启用</c-table-button>
                      <c-table-button v-if="auth('b_limit_time_discount_view')" @click="navigateTo(`/limit_time_discount_detail/${row.data.id}`)">查看</c-table-button>
                      <c-table-button v-if="auth('b_limit_time_discount_edit') && row.data.start_state != 2" @click="navigateTo(`/limit_time_discount_edit/${row.data.id}`)">修改</c-table-button>
                      <c-table-button v-if="auth('b_limit_time_discount_edit') && (row.data.start_state == 0 || row.data.start_state == 2 || row.data.start_state == 3)" @click="deleteActivity(row)">删除</c-table-button>
                      <c-table-button v-if="auth('b_limit_time_discount_edit') && row.data.start_state != 2" @click="copyActivity(row)">复制</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_limit_time_discount',

        data() {
            return {
                commodityTange: {
                  1: '指定商品',
                  2: '指定品牌'
                },
                activityState: [{
                    name: '未开始',
                    value: 0
                }, {
                    name: '进行中',
                    value: 1
                }, {
                    name: '暂停中',
                    value: 3
                }, {
                    name: '已结束',
                    value: 2
                }
                ]

            }
        },

        computed: {
            activityStateText() {
                var state = {};
                this.activityState.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/activitySale/list',
                    data
                });
            },

            disableActivity(item,state) {
                this.$confirm({
					title: '温馨提示',
                    message: state == 2 ? '确定要开始此限时折扣活动吗？' : '确定要暂停此限时折扣活动吗',
                    resolve: () => {
                        this.request({
                            url: '/activitySale/updateActivityState',
                            data: {
                                id: item.data.id,
                                state:state
                            },
                            loading: true,
                            success: (data,obj,a) => {
                                this.$message({
									type:'success',
                                    message: state == 2 ? '启用成功' : '禁用成功'
                                });
                                this.$refs.table.update();


                            }
                        });
                    },
					cancel: () => {}
                });
            },

            deleteActivity(item) {
                this.$confirm({
					title: '温馨提示',
                    message: '确定要删除此限时折扣活动吗？',
                    resolve: () => {
                        this.request({
                            url: '/activitySale/delete',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
									type:'success',
                                    message: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },
            copyActivity(item) {
                this.request({
                    url: '/activitySale/copy',
                    data: {
                        id: item.data.id
                    },
                    loading: true,
                    success: () => {
                        this.$message({
							type:'success',
                            message: '复制成功'
                        });
                        this.$refs.table.update();
                    }
                });
            }
        }
    }
</script>